import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class AdLink extends PureComponent {
    static propTypes = {
        content: PropTypes.object.isRequired,
        methods: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.clickData = null;
        this.wrapRef = React.createRef();
    }

    handleMouseDown = (e) => {
        if (e.button === 0) {
            this.clickData = {
                startTime: Date.now(),
            };
        }
    };

    handleMouseUp = (e) => {
        if (e.button === 0 && this.clickData) {
            this.clickData.endTime = Date.now();
        }
    };

    handleClick = (e) => {
        const { content, methods } = this.props;
        const { clickUrl, index } = content;
        const { handleAdLinkClick } = methods;

        if (this.clickData && this.clickData.startTime) {
            if (!this.clickData.endTime) {
                this.clickData.endTime = Date.now();
            }

            try {
                const pointerClientX = e.clientX;
                const pointerClientY = e.clientY;
                const {
                    x: adLinkX,
                    y: adLinkY,
                    width: adSpaceWidth,
                    height: adSpaceHeight,
                } = this.wrapRef.current.getBoundingClientRect();
                const offsetX = pointerClientX - adLinkX;
                const offsetY = pointerClientY - adLinkY;

                this.clickData.offsetX = offsetX;
                this.clickData.offsetY = offsetY;
                this.clickData.adSpaceWidth = adSpaceWidth;
                this.clickData.adSpaceHeight = adSpaceHeight;
            } catch (e) {
                console.error(e);
                this.clickData = null;
            }
        } else {
            this.clickData = null;
        }

        let macroUrl = clickUrl;

        if (this.clickData) {
            const { startTime, endTime, offsetX, offsetY, adSpaceWidth, adSpaceHeight } = this.clickData;
            macroUrl = macroUrl
                .replace('__EVENT_TIME_START__', parseInt(startTime, 10))
                .replace('__EVENT_TIME_END__', parseInt(endTime, 10))
                .replace('__OFFSET_X__', parseInt(offsetX, 10))
                .replace('__OFFSET_Y__', parseInt(offsetY, 10))
                .replace('__ADSPACE_W__', parseInt(adSpaceWidth, 10))
                .replace('__ADSPACE_H__', parseInt(adSpaceHeight, 10))
                .replace('__VIDEO_ACTION_ID__', '2');
        }

        window.open(macroUrl);
        handleAdLinkClick(index, this.clickData);
    };

    render() {
        return (
            <div
                className={styles.wrap}
                ref={this.wrapRef}
                onClick={this.handleClick}
                onMouseDown={this.handleMouseDown}
                onMouseUp={this.handleMouseUp}>
                <div className={styles.detail}>
                    <div className={styles.detailText}>查看广告详情</div>
                    <div className={styles.detailIcon} />
                </div>
            </div>
        );
    }
}

export default AdLink;
